import styled from "styled-components";

const Box = styled.div`
  max-width: 600px;
  color: #4b5882;
  background-color: #fff;
  border-radius: 10px;
  padding: 10px;
  font-size: 12px;
  border: 1px solid #a5acc2;
  align-self: flex-start;
`;

const Row = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
`;
const Col = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
`;

const Label = styled.span`
  font-weight: bold;
`;

const Info = styled.p`
  line-height: 1.4;
  position: relative;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const RecommendationInfo = ({
  recId,
  status,
  organization,
  Pillar,
  supportTask,
}) => {
  return (
    <Box>
      <Row>
        <Label>Recommendation ID</Label>
        <Col>
          <Info>{recId}</Info>
        </Col>
      </Row>
      <Row>
        <Label>Status</Label>
        <Col>
          <Info>{status}</Info>
        </Col>
      </Row>
      <Row>
        <Label>Organization</Label>
        <Col>
          <Info>{organization}</Info>
        </Col>
      </Row>
      <Row>
        <Label>Pillar</Label>
        <Col>
          <Info>{Pillar}</Info>
        </Col>
      </Row>
    </Box>
  );
};

export default RecommendationInfo;
